import type * as React from "react";
import { cn } from "@/lib/utils";

interface DataToolbarProps {
  /** Search input element (usually `<SearchInput ... />`). */
  search?: React.ReactNode;
  /** Filter controls — typically a row of `<Select>` elements. */
  filters?: React.ReactNode;
  /** Primary actions, right-aligned. Usually a `<Button>` like "Add X". */
  actions?: React.ReactNode;
  className?: string;
}

/**
 * Standard list-page toolbar: left-aligned search + filters, right-aligned actions.
 *
 * Used at the top of every list page (people, users, roles, …). Slots are optional
 * so the same component covers admin tables (actions only) and read-only lists.
 */
export function DataToolbar({ search, filters, actions, className }: DataToolbarProps) {
  return (
    <div
      className={cn(
        "flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between",
        className,
      )}
    >
      <div className="flex flex-1 flex-wrap items-center gap-3">
        {search}
        {filters}
      </div>
      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </div>
  );
}
